import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const customStyles = {
    sonicLinkStyle: {
        css: css`
            display: flex;
            justify-content: center;
            font-family: "Pancetta W05 Regular", sans-serif;
            font-weight: 700;
            color: ${getColor("text.main")};
            font-size: 16px;
            gap: 10px;

            svg {
                animation-duration: 0.663s;
                animation-name: animate-chevrons;
                animation-iteration-count: 3;
                animation-direction: alternate;
                animation-play-state: paused;
            }

            &:hover {
                svg {
                    animation-play-state: running;
                }
            }

            @keyframes animate-chevrons {
                0% {
                    transform: translate(-10px);
                }

                100% {
                    transform: translate(2px);
                }
            }
        `,
    },
};
